import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import Node from './Node';
import {selectNode} from '~app/actions/nodeList';
import defined from '~app/core/defined';
import Logging from '~app/core/logging';
import { withT, withResources } from "~app/BundleProvider";

const log = Logging.getLogger('app.components.nodelist');

const SortableNode = SortableElement(({label, info, key, select, isSelected})=>
                    <Node index={label}
                          info={info}
                          key={key}
                          select={select}
                          isSelected={isSelected}/>);

const NodeList = SortableContainer(({list, selectNode, t, r}) => (
  <div className="NodeList">
    {defined(list.nodes) && list.nodes.length === 0 && <img src={r("CallToAction.svg")}  alt={t("select-event")} />}
    {defined(list.nodes) && list.nodes.map( (n,i) => (
      <SortableNode index={i}
                    label={i+1}
                    info={n}
                    key={n.id}
                    select={() => selectNode(n.id, n.buttonId, n.title, n.className)}
                    isSelected={list.selected.id===n.id}/>
    ) ) }
  </div>
));

NodeList.selectNode = (id, buttonId) => {
  // Deselect any selected node?
  // Select this node
  log.debug("id:" + id + " buttonId:" + buttonId);
};

NodeList.propTypes = {
  list: PropTypes.object,
  t: PropTypes.func,
};

const mapDispatchToProps = {
  selectNode,
};

export { NodeList };
export default withResources(withT(connect(null, mapDispatchToProps)(NodeList)));



// WEBPACK FOOTER //
// ./src/pages/Main/NodeList/NodeList.js